<script>
import axios from "axios";
import * as Sentry from "@sentry/browser";

const MAX_TRIES = 2;

export default {
  data() {
    return {
      validGenesList: null,
      genesOptionsValueObj: {},
      debounceDelay: 300,
      typingTimeout: null,
      isSearchingGenes: null,
      genesSearchMsg: "Start typing for finding results",
      foundGenesData: false,
      brokenGenesApi: false,
    };
  },
  methods: {
    handleGenesSearchChange(searchQuery) {
      if (!searchQuery) {
        return;
      }

      // Clear the previous timer
      clearTimeout(this.typingTimeout);

      // Set a new timer to call the API after debounceDelay milliseconds
      this.typingTimeout = setTimeout(async () => {
        this.isSearchingGenes = true;

        let res;

        try {
          res = await this.retrieveGenesList(searchQuery);
        } catch (error) {
          console.error("Caught error when calling retrieveGenesList", error);
          Sentry.captureException(
            `Caught error when calling retrieveGenesList: ${error}`
          );
        }

        this.isSearchingGenes = false;

        if (!res) {
          this.brokenGenesApi = true;

          this.$set(this, "validGenesList", []);
          this.$set(this, "foundGenesData", false);
          this.$set(this, "indGenes", []);
          return;
        }

        const data = res.data;
        if (data) {
          if (data.length === 0) {
            this.foundGenesData = false;
            this.genesSearchMsg = "No results found";
          } else {
            this.foundGenesData = true;

            let genesOption = [];

            data.forEach((gene) => {
              const hgncSymbol = gene.attributes.hgncSymbol;

              // Adding a new key-value pair reactively for data in Vue2
              this.$set(
                this.genesOptionsValueObj,
                hgncSymbol,
                gene.attributes.hgncId
              );

              genesOption = [...genesOption, `${hgncSymbol}`];
            });

            // Add selected genes in validGenesList to make use of built-in <auto-complete> UI feature
            this.validGenesList = [...genesOption, ...this.indGenes];
          }
        }
      }, this.debounceDelay);
    },
    async retrieveGenesList(searchQuery) {
      let res = null;

      // Try API call twice before displaying Alert on the screen
      for (let i = 1; i <= MAX_TRIES; i++) {
        try {
          res = await this.callGenesApi(searchQuery);

          if (res && res.status === 200) return res.data;
        } catch (error) {
          console.error("Caught error when calling callGenesApi", error);
        }
      }
    },
    async callGenesApi(searchQuery) {
      const genesSearchEndpoint = `${this.$dataset.externalCms}/api/mendeliome-genes?filters[$or][0][hgncId][$containsi]=${searchQuery}&filters[$or][1][hgncSymbol][$containsi]=${searchQuery}`;

      try {
        return await axios.get(genesSearchEndpoint);
      } catch (error) {
        console.error(
          `Caught error when making API call to ${genesSearchEndpoint}:`,
          error
        );
      }
    },
    filterGenesItems(item, queryText, itemText) {
      // Overwrite default `filter` props for v-autocomplete to display results that does not contain search query input string
      // For more: https:github.com/vuetifyjs/vuetify/blob/v2-stable/packages/vuetify/src/components/VAutocomplete/VAutocomplete.ts#L40

      return queryText && this.foundGenesData;
    },
    // Convert indGenes value to the form of "<hgncId> - <hgncSymbol>|<hgncId> - <hgncSymbol>|..."
    getFinalIndGenes(indGenesArr) {
      return indGenesArr
        .map(
          (geneHgncSymbol) =>
            this.genesOptionsValueObj[`${geneHgncSymbol}`] +
            " - " +
            geneHgncSymbol
        )
        .join("|");
    },
    // Used to display indGenes value in Summary screen for prenatal test(s)
    displayPrenatalIndGenesList(pipedVal) {
      return pipedVal.replace(/\|/g, ", ");
    },
  },
};
</script>
